module.exports = __webpack_public_path__ + "static/media/logospace.6d3e09d3.jpg";